module.exports = __webpack_public_path__ + "static/media/venetian04.d9997ec8.png";